var _circle, _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectManagement({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#1D3066"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7191 11.6247L17.0194 12H17.5H21C21.5523 12 22 12.4477 22 13V20C22 20.5523 21.5523 21 21 21H9C8.44772 21 8 20.5523 8 20V11V10.5C8 9.94772 8.44772 9.5 9 9.5H14.5388C14.8425 9.5 15.1298 9.63809 15.3196 9.8753L16.7191 11.6247Z",
    stroke: "white",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 17,
    width: 4,
    height: 2,
    rx: 1,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectManagement);
export default __webpack_public_path__ + "static/media/project-management.03444eb5d3367fde7cd2bd2a7d0ef5f1.svg";
export { ForwardRef as ReactComponent };